import { createSlice } from '@reduxjs/toolkit';
import storage from '../../services/storage';

const user = storage.get('user') || {
  firstName: '',
  lastName: '',
  _id: '',
  email: '',
  schoolTimeZone: '',
  isBookOpened: '',
};

const token = storage.get('xAuthToken') || '';

const initialState = {
  token,
  user,
};

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      //state.crClass
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    updateUser: (state, action) => {
      // Assuming action.payload contains the updated user information
      state.user = {
        ...state.user,
        ...action.payload,
      };
    },
    resetAuth: (state) => {
      state.token = '';
      state.user = {};
      // state = {
      //     token: "",
      //     user: {
      //         firstName: "",
      //         lastName: "",
      //         _id: "",
      //         email: "",
      //     },
      // };
    },
  },
});

export const { setUser, setToken, resetAuth, updateUser } = slice.actions;
export default slice.reducer;
